<template>
    <div class="btnGroup">
        <div class="btns">
            <div class="btnItem">
                <slot></slot>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'OrderBtn',
    data(){
        return {

        }
    }
}
</script>

<style lang="scss" scoped>

.btnGroup{
        width: 100%;
        height: 4.5rem;
        .btns{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 4.5rem;
            background: #fff;
            padding:0 1rem;
            box-sizing: border-box;
            .btnItem{
                width: 100%;
                height: 4.5rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 1rem;
               
            }
            
        }
    }
</style>